import React, {useReducer} from 'react';
import { useHistory } from "react-router-dom";
import gql from 'graphql-tag';
import { isMobile } from "react-device-detect";


import {
  USERS_CONNECTION_QUERY
} from '../api/homepage'

import { handleArtistClick } from '../utils'
import { colors, fontSizes} from '../styles/defaultTheme';
import ErrorPage from '../components/ErrorPage';
import Header from '../components/Header';
import RecommendedUser from '../components/RecommendedUser';
import Footer from '../components/Footer';
import Button from '../components/Button';
import Input from '../components/Input'


import WindowSizeListener from 'react-window-size-listener'
import { Helmet } from "react-helmet";
import MailchimpSubscribe from "react-mailchimp-subscribe"

import { useQuery, useMutation } from 'react-apollo-hooks';

import '../styles/App.scss'
import fullLogo from '../images/full-logo.svg'
import loadingIcon from '../images/load-disk.png';
import { quotes } from '../quotes'
import logoSingle from '../images/BT_Filled_Secondary_Logo_Black.svg'
import twitter from '../images/twitter-blk.svg'
import instagram from '../images/instagram-blk.svg'
import copyIcon from '../images/copy-icon.svg';
import arrowDirection from '../images/subscribe-button.svg';





const reducer = (state, action) => {
  switch (action.type) {
    default:
      return { ...state, ...action.payload };
  }
};

const initialState = () => ({
  about: true,
  renderShareModal: true,
  urlCopied: false
})

const LandingPage = ({pathname, masterPassword, handleAccessRedirect, currentUser, allSkills}) => {

  const url = process.env.REACT_APP_MAILCHIMP_URL;

  const SimpleForm = () => <MailchimpSubscribe url={url}/>

  return (
    <div className="default-app">
      <div className="default-app__social-wrapper social-header">
        <a rel="noreferrer" target="_blank" href="https://twitter.com/rapchr"><img className="default-app__icon" alt="twitter" src={twitter} /></a>
        <a rel="noreferrer" target="_blank" href="https://www.instagram.com/rapchr.app/"><img className="default-app__icon" alt="instagram" src={instagram} /></a>
      </div>
      <img className="default-app__logo" alt="Rapchr" src={logoSingle} />
      {isMobile && <img className="default-app__gif" alt="rapchr" src="https://res.cloudinary.com/rapchr/image/upload/v1622161596/IMG_9015_zkmc4l.gif" />}
      {!isMobile && <div className="default-app__video__wrapper">
        <video className="default-app__video" autoPlay="autoplay" loop="loop" muted>
          <source src="https://res.cloudinary.com/rapchr/video/upload/v1621250325/IMG_9015_lexnde.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>}
      <div className="default-app__social-wrapper-bottom social-footer">
        <a rel="noreferrer" target="_blank" href="https://twitter.com/rapchr"><img className="default-app__icon" alt="twitter" src={twitter} /></a>
        <a rel="noreferrer" target="_blank" href="https://www.instagram.com/rapchr.app/"><img className="default-app__icon" alt="instagram" src={instagram} /></a>
      </div>
      <div className="default-app__about-section">
        <div className="default-app__about-header">
          A social platform <span>dedicated to rap</span>
        </div>
        <div>
        <a style={{textDecoration: "none"}} rel="noreferrer" href="https://www.rapchr.app/"><p className="default-app__about-msg">
          Head to Rapchr's website to sign up for updates.
        </p></a>
        <a rel="noreferrer" href="https://www.rapchr.app/"><img className="default-app__arrow" alt="Rapchr Website Direction" src={arrowDirection} /></a>
        </div>
      </div>
      <div className="default-app__footer">
       <p className="default-app__footer-link">© 2025 Rapchr Inc.</p>
       <a className="default-app__contact default-app__footer-link" href="mailto:support@rapchr.app">Contact Us</a>
     </div>
    </div>
  )

}


export default LandingPage
